type ScreenWrapperProps = {
	children: React.ReactNode;
};
const ScreenBody = ({ children }: ScreenWrapperProps) => {
	return <div className="p-2">{children}</div>;
};

export { ScreenBody };
